import React, { useEffect, useMemo, useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import { doRequestGet } from '../../../api'
import { toast } from 'react-toastify'
import { getDate, promiseCatch } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { FormCustom, Input } from '../../../components/form'
import SelectCustom from '../../../components/select-custom/SelectCustom'
import ReactPlaceholder from 'react-placeholder/lib'
import LoadingIcon from '../../../components/loading/LoadingIcon';
import ReactDataTableBootstrap from 'react-table-bootstrap'

export const ReporteDetalladoView = () => {
  const [form, setForm] = useState({
    p_id_event: '',
    p_date_start: getDate({ addDays: -7 }),
    p_date_end: getDate(),
  })

  const [execute, setExecute] = useState(false)
  const { rows, setReload, isProcessing, error, setError, setRows } = useGet({
    url: `/event/report/detallado/${form.p_id_event}/${form.p_date_start}/${form.p_date_end}`,
    execute
  })

  const [events, setEvents] = useState([])
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const reqEvents = async () => {
      const getEvents = await doRequestGet({
        url: '/event'
      })

      setEvents(getEvents.data)
      setReady(true)
    }

    reqEvents()
  }, [])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])

  const dtRows = useMemo(() => {
    const headItem = [
      { name: 'Fecha', text: 'Fecha', align: 'center' },
    ]

    if (rows?.rows?.length > 0) {
      for (const key in rows?.rows[0]) {
        if (key !== 'Fecha') {
          headItem.push({ name: key, text: key, align: 'center' })
        }
      }
    }

    return <ReactDataTableBootstrap
      head={[headItem]}
      rows={rows?.rows}
      isProcessing={isProcessing}
      orderDirection={'desc'}
      columnOrder={'date_pay'}
      pageLength={50}
    />
  }, [rows, isProcessing])

  return <div className='row'>
    {isProcessing ? <LoadingIcon /> : ''}
    <div className="col-12">
      <Card>
        <Card.Body>
          <ReactPlaceholder ready={ready} rows={7} showLoadingAnimation>
            <FormCustom onSubmit={_ => {
              if (!isNaN(parseInt(form.p_id_event))) {
                setReload(true)
                setExecute(true)
              }
            }} viewSubmit={false}>
              <Input
                classNameParent="col-md-6 mb-2"
                value={form.p_date_start}
                onChange={e => setForm({ ...form, p_date_start: e.target.value })}
                type="date"
                text="Fecha Inicio"
              />
              <Input
                classNameParent="col-md-6 mb-2"
                value={form.p_date_end}
                onChange={e => setForm({ ...form, p_date_end: e.target.value })}
                type="date"
                text="Fecha Fin"
              />
              <SelectCustom
                valueId={form.p_id_event}
                keyName="event"
                options={events}
                setRow={setForm}
                row={form}
                selectText="Eventos"
                onChangeAdd={_ => {
                  setRows([])
                }}
                selectPops={{
                  append: [
                    <Button type="submit">
                      <i className='fa fa-search'></i>
                    </Button>
                  ]
                }}
                showEnabled={false}
              />
            </FormCustom>
            {rows?.excel?.file ? <div className="d-flex mb-2">
              <div className='mt-2 mb-2 me-2'>
                <a href={rows?.excel?.file} download={rows?.excel?.name}>
                  <Button variant="success" className='text-white'>
                    <i className="fa fa-file-excel me-2"></i>Descargar Reporte Excel
                  </Button>
                </a>
              </div>
            </div> : ''}
            {dtRows}
          </ReactPlaceholder>
        </Card.Body>
      </Card>
    </div>
  </div>
}